import { render, staticRenderFns } from "./BannedVisitors.vue?vue&type=template&id=42e3ceee"
import script from "./BannedVisitors.vue?vue&type=script&lang=js"
export * from "./BannedVisitors.vue?vue&type=script&lang=js"
import style0 from "./BannedVisitors.vue?vue&type=style&index=0&id=42e3ceee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports